export default /*@ngInject*/ function (homeDataService) {

    const vm = this;
    //State
    vm.currentView = 'library'; // 'library' or 'visualization'
    vm.backToLibrary = backToLibrary;

    // Instance tracking
    vm.libraryInstanceId = null;
    vm.visualizationInstanceId = null;

    vm.accessToken = null;
    vm.setVisualizationView = setVisualizationView;
    vm.embedManager = null;
    vm.themeId = 'modern';

    async function activate() {
        let authenticateResponse = await homeDataService.authenticateUser();
        vm.accessToken = authenticateResponse.data.Token;

        await getThemes();

        await window.initComposerEmbedManager({ "initialToken": vm.accessToken })
            .then(function (manager) {
                console.log('Embed manager initialized');
                vm.embedManager = manager;
            }).catch(function (err) {
                console.error('Failed to initialize embed manager:', err);
            });

        await setupVisualizationLibraryComponent();
    }

    activate();

    async function getThemes() {
        const themesUrl = `${logiUrl}discovery/api/customization/themes`;
        const headers = {
            'Accept': 'application/vnd.composer.v3+json',
            'Content-Type': 'application/vnd.composer.v3+json',
            'Authorization': 'Bearer ' + vm.accessToken
        }
        const response = await fetch(themesUrl, { headers });
        const data = await response.json();

        if (data.content) {
            vm.themeId = data.content.filter(d => d.name === 'Delinea')[0].id;
        }
    }

    async function setupVisualizationLibraryComponent() {
        vm.currentView = 'library';

        const componentConfig = {
            "inventoryItem": "visual",
            "theme": vm.themeId,
            "components": {
                "filters": {
                    "visible": false,
                },
                "search": {
                    "visible": false,
                },
                actions: {
                    visible: true,
                    showDefaults: true,
                    order: ["import-visual", "add-new-visual"],
                    visibility: ["import-visual", "add-new-visual"],
                    definitions: [{
                        id: "add-new-visual",
                        label: "Create Visual",
                        intent: "primary",
                        onClick: async function () {
                            console.log('Create new visual clicked');
                            await vm.setVisualizationView(null);
                        }
                    }]
                },
                "table": {
                    "defaultSort": {
                        "colId": "name", // ["favorite", "name", "dataSource", "author", "dateModified", "permissions", "schedule", "actions"]
                        "sortDirection": "asc"
                    },

                    "columns": {
                        "showDefaults": true,

                        "order": [
                            "name",
                            "dataSource",
                            "author",
                            "dateModified",
                            "permissions",
                            "schedule",
                            "actions"
                        ],
                        "visibility": [
                            "name",
                            "dataSource",
                            "author",
                            "dateModified",
                            "permissions",
                            "schedule",
                            "actions"
                        ],


                        "definitions": [
                            {
                                colId: "name",
                                cellRendererParams: {
                                    onClick: async function (inventoryItem) {
                                        let visualId = inventoryItem.inventoryItemId;
                                        let visualName = inventoryItem.name;
                                        console.log('Opening visual:', visualId, visualName);
                                        await vm.setVisualizationView(visualId);
                                    }
                                }
                            }
                        ]
                    }
                }
            },
            "interactivityOverrides": {
                "name": "interactive",
                "type": "SYSTEM",
                "overrideVisualInteractivity": true,
                "settings": {
                    "DELETE": true,
                    "FILTER": true,
                    "IMPORT": true,
                    "ADD_NEW": true,
                    "PERMISSIONS": true,
                    "MULTI_SELECTION": true,
                    "EXPORT": true,
                    "FAVORITES": true,
                    "DESCRIPTION": true,
                    "TAGS": true,
                }
            },
        }


        let component = await vm.embedManager.createComponent("inventory", componentConfig);
        vm.libraryInstanceId = component.componentInstanceId;
        await component.render(document.getElementById("library-container"), { width: "100%", height: "100%" });
    }

    async function setVisualizationView(visualId) {
        vm.currentView = 'visualization';

        const componentConfig = {
            "originId": "",
            "visualId": visualId,
            "interactivityProfileName": "interactive",
            "theme": vm.themeId,
            "editor": { "placement": "modals" },
            "header": {
                "showActions": true,
                "showTitle": true,
                "visible": true
            }
        };

        let component = await vm.embedManager.createComponent("visual-builder", componentConfig);
        vm.visualizationInstanceId = component.componentInstanceId;
        await component.render(document.getElementById("visual-container"), { width: "100%", height: "100%" });
        await component.addEventListener('composer-visual-saved', async function (event) {
            console.log('Visual saved event:', event);
            await vm.embedManager.refreshComponent(vm.libraryInstanceId);
        });
    }

    async function backToLibrary() {
        if (vm.visualizationInstanceId) {
            await vm.embedManager.removeComponent(vm.visualizationInstanceId);
        }

        vm.currentView = 'library';
    }
}
